import { render, staticRenderFns } from "./member-theme-dialog.vue?vue&type=template&id=edee54a4&scoped=true"
import script from "./member-theme-dialog.vue?vue&type=script&lang=js"
export * from "./member-theme-dialog.vue?vue&type=script&lang=js"
import style0 from "./member-theme-dialog.vue?vue&type=style&index=0&id=edee54a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edee54a4",
  null
  
)

export default component.exports